import { ShopClientInfo } from 'actions/actionTypes';

export const editShopClientPasswordRequest = (shopGuid,newPassword) => {
    return {
        type: ShopClientInfo.EDIT_SHOP_CLIENT_PW_REQUEST,
        payload: {
            shopGuid,
            newPassword, // 전달받은 비밀번호를 payload로 전달
        },
    };
};

export const editShopClientPasswordRequestSuccess = responseData => ({
    type: ShopClientInfo.EDIT_SHOP_CLIENT_PW_REQUEST_SUCCESS,
    payload: { responseData }, // responseData를 객체로 통일
});

export const editShopClientPasswordRequestFailure = errorMessage => ({
    type: ShopClientInfo.EDIT_SHOP_CLIENT_PW_REQUEST_FAILURE,
    payload: { errorMessage }, // errorMessage를 객체로 통일
});

